import { createApp } from 'vue'
import FPaginator from '~/js/components/paginator'
import { isDesktop } from '~/js/templates/index/helpers'

const CLASS_NAME = 'js-blogPaginator'

document.addEventListener('DOMContentLoaded', () => {
  const elements = document.getElementsByClassName(CLASS_NAME)
  if (!elements.length) return

  Array.from(elements).forEach((element) => {
    const articleCountSp = element.dataset.articleCountSp
    const articleCountPc = element.dataset.articleCountPc
    const itemPerPage = isDesktop() ? articleCountPc : articleCountSp
    createApp({
      name: 'TemplatesBlogPaginator',
      data() {
        return {
          itemPerPage,
        }
      },
      components: {
        FPaginator,
      },
    }).mount(element)
  })
})
